<div class="row">
  <div class="flex justify-between items-center mb-2">
    <h4 class="m-0!">ویدیوهای آموزشی</h4>
    <p-button
      outlined
      routerLink="/e-workshops"
      label="{{ 'homePage.labels.seeAll' | translate }}"
    >
    </p-button>
  </div>

  <div class="col-12 p-0 d-md-none">
    <swiper-container [navigation]="true" [loop]="true">
      <swiper-slide *ngFor="let item of eworkshops()">
        <div class="m-5">
          <ng-container
            *ngTemplateOutlet="eworkshopCard; context: { $implicit: item }"
          ></ng-container>
        </div>
      </swiper-slide>
    </swiper-container>
  </div>

  <div class="col-12 d-none d-md-block">
    <div class="col-5-grid gap-3">
      <div *ngFor="let item of eworkshops()">
        <ng-container
          *ngTemplateOutlet="eworkshopCard; context: { $implicit: item }"
        ></ng-container>
      </div>
    </div>
  </div>

  <ng-template #eworkshopCard let-item>
    <app-e-workshop-card [workshop]="item"></app-e-workshop-card>
  </ng-template>

  <ng-template #eworkshopCard2 let-item>
    <div
      class="bg-white shadow p-3 rounded d-flex flex-column"
      style="height: 280px"
    >
      <afra-image
        [fileId]="item.coverImage"
        imgClass="card-img-top rounded object-fit-cover"
        alt="..."
        style="height: 150px"
      ></afra-image>
      <div class="card-body d-flex flex-column grow h-0">
        <div class="mt-2 grow h-0 w-100 text-elipsis d-inline-block">
          <a
            [href]="item.link"
            class="text-decoration-none text-reset"
            target="_blank"
          >
            <p class="threeline-ellipsis">{{ item.title }}</p>
          </a>
        </div>
        <div>
          <ng-icon name="lucideUser" class="me-2 text-secondary"></ng-icon>
          <span class="text-secondary">{{ item.teacherFullName }}</span>
        </div>
      </div>
    </div>
  </ng-template>
</div>
